module.exports = __webpack_public_path__ + "img/gfx-step-4_x3.d2a0ce1e.webp";